import { render, staticRenderFns } from "./group_modal.vue?vue&type=template&id=12b59fd2&scoped=true&"
import script from "./group_modal.vue?vue&type=script&lang=js&"
export * from "./group_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b59fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b59fd2')) {
      api.createRecord('12b59fd2', component.options)
    } else {
      api.reload('12b59fd2', component.options)
    }
    module.hot.accept("./group_modal.vue?vue&type=template&id=12b59fd2&scoped=true&", function () {
      api.rerender('12b59fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/group/group_modal.vue"
export default component.exports